module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABa0lEQVQ4T+2SPSxDURzF/+e+kthrNBiEUSLMImFhFJu1pWmLwdL3xOP1Y5NoX5uw2STEx2CiymI3CIkYbWwSS3uPPPGeohofsbnLzf3fk19Ozv9AXk7c4SDALYGE/VmzmyIUyk64ignbhoYvTqRrS4S6dU2sfwUkJOIZXugqBko2Hl5BWbZTs6wEU3kLZ81gtk11F+KmAOeuiYynDUDeI5ZmhwKPRCPqLuCkEcy2GboPcZvCa9cy5n3NG5A3jDvsFLBMIFo0cVgPi6yxpfWO+yBvCpaRqP/7API+kw67NFhRwGTeRCVYSFofiPDWtYzIe7cNQZ4o4XCEYMS11LjvFIp7hRR6BeCXQbEc+w3NxYKpxp5BWfaALBVMNdQou08d/YOCuP4+o2SOfbrGZddSo7/a2twK26qPvNLEbNHC7o/X77mYcditFU81MQ0llz/qkZ9iABOsKuHwtwtZ314PVlM8FuGGaxqpRs1+Anmw5BMC3jTvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/envi-word.png
// module id = ORzA
// module chunks = 105